import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

export const STORE_ROUTES: Routes = [
  {
    path: 'list',
    loadComponent: () => import('./store-list/store-list.component').then(m => m.StoreListComponent),
    canActivate: [AuthGuard], data: { requireSignIn: false }
  },
  {
    path: 'list/:category',
    loadComponent: () => import('./store-list/store-list.component').then(m => m.StoreListComponent),
    canActivate: [AuthGuard], data: { requireSignIn: false }
  },
  {
    path: 'admin',
    loadComponent: () => import('./store-admin/store-admin.component').then(m => m.StoreAdminComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true, requireStoreAdmin: true }
  },
  {
    path: 'uber-eats',
    loadComponent: () => import('./uber-eats/uber-eats.component').then(m => m.UberEatsComponent),
    canActivate: [AuthGuard], data: { requireSignIn: false }
  }
];
